import { render, staticRenderFns } from "./TourDetailView.vue?vue&type=template&id=4b477352"
import script from "./TourDetailView.js?vue&type=script&lang=js&external"
export * from "./TourDetailView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports